import React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
    TextField,
    Grid,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    CircularProgress,
    Popper,
    Tooltip
} from '@material-ui/core';
import moment from 'moment';
// import ArrowRightIcon from '@material-ui/icons/ArrowRight';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { SubmitSnackbar, EnhancedParentChildTable } from '../../components';
import { stringConstants } from '../../constants/stringConstants';
import { globalDateEntity, DatepickerStartDate } from '../../constants/applicationConstants';
import Collapse from '@material-ui/core/Collapse';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import GetAppIcon from '@material-ui/icons/GetApp';
import './eventLogs.css';
import { Button } from '@material-ui/core';
// import { UI_LABELS, filterProps } from './uiLabels'
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer'
import _ from 'underscore'
import { filterProps, UI_LABELS, categoryList, events, categoryMap, eventsMap } from './uiLabels';
import EnhancedAutoComplete from '../../components/enhancedAutoComplete/EnhancedAutoComplete';
import { Formik } from 'formik';
import LocalStorageService from '../../services/localStorage';
import { Alert } from '@material-ui/lab';
import { sortDataList } from '../../submodule';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';

const EventLogs = (props) => {
    const reportAction = useStoreActions((actions) => actions.report);
    const reportState = useStoreState((state) => state.report.eventLogs);
    const reportStateDownload = useStoreState((state) => state.report.downloadUserLogsList);
    const userAction = useStoreActions((actions) => actions.userList);
    const userState = useStoreState((state) => state.userList);
    const [loadingState, setLoadingState] = React.useState(true);
    const [showDownloadButton, setShowDownloadButton] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [emailAddressFieldKey, setEmailAddressFieldKey] = React.useState(new Date().getTime());
    const [responseReceived, setResponseReceived] = React.useState(false);
    const [eventLogsList, setEventLogsList] = React.useState([]);

    // let userRole = {};
    // try {
    //     userRole = JSON.parse(LocalStorageService.getUserInfo());
    //     if (
    //         userRole.roles &&
    //         userRole.roles.title.toLowerCase() ===
    //         currentUserEntity.tenantUser
    //     ) {
    //         categoryList = [
    //             'users',
    //             'programs',
    //             'association',
    //             'policies_version',
    //             'customize_policy',
    //             'customize',
    //             'instructions',
    //             'businesslines',
    //             'policies',
    //         ];
    //     }
    // } catch (error) {
    //     console.log('error - ', error)
    // }


    const [filterData, setFilterData] = React.useState({
        username: [],
        category: categoryList,
        event_type: events?.sort()
    });

    const [selectedFilter, setSelectedFilter] = React.useState({
        username: '',
        category: '',
        event_type: '',
        search: '',
        start_date: '',
        end_date: ''
    });
    // const commonAction = useStoreActions((actions) => actions.common);

    const newStyles = {
        variables: {
            light: {
                codeFoldGutterBackground: "#6F767E",
                codeFoldBackground: "#E2E4E5"
            }
        }
    };

    const urlParams = window.location.search;
    let queryStr = '';
    const initializeQueryStr = (prop, defaultVal) => {
        let val = 0;
        // init queryStr properties
        if (queryStr.has(prop)) {
            //validate value
            val = queryStr.get(prop) * 1;
            if (isNaN(val) || val <= 0) {
                val = defaultVal;
            }
            queryStr.set(prop, val);
        } else {
            queryStr.append(prop, defaultVal);
        }
    }


    // const initializeStateFromQueryStr = (queryStr) => {
    //     console.log('______ Before => ', queryStr.toString());
    //     let val = 0;
    //     // init queryStr properties
    //     let keys = queryStr.keys();
    //     for (const key of keys) {
    //         console.log(key)
    //         switch (key) {
    //             case 'limit':
    //                 if (queryStr.has(key)) {
    //                     val = queryStr.get(key) * 1;
    //                     if (isNaN(val) || val <= 0) {
    //                         val = 10
    //                     }
    //                     queryStr.set(key, val);
    //                 } else {
    //                     queryStr.append(key, 10);
    //                 }
    //                 setRowsPerPage(queryStr.get(key));
    //                 break;
    //             case 'page':
    //                 if (queryStr.has(key)) {
    //                     val = queryStr.get(key) * 1;
    //                     if (isNaN(val) || val <= 0) {
    //                         val = 1
    //                     }
    //                     queryStr.set(key, val);
    //                 } else {
    //                     queryStr.append(key, val);
    //                 }
    //                 setCurrentPage(queryStr.get(key));
    //                 break;
    //             case 'username':
    //             case 'category':
    //             case 'event_type':
    //             case 'search':
    //                 if (queryStr.has(key)) {
    //                     val = queryStr.get(key);
    //                     queryStr.set(key, val);
    //                 } else {
    //                     queryStr.append(key, '');
    //                 }
    //                 setSelectedFilter({ ...selectedFilter, [key]: queryStr.get(key) })
    //                 break;
    //             case 'end_date':
    //             case 'start_date':
    //                 if (queryStr.has(key)) {
    //                     val = queryStr.get(key);
    //                     let date = moment(val);
    //                     if (!date.isValid()) {
    //                         val = ''
    //                     }
    //                     queryStr.set(key, val);
    //                 } else {
    //                     queryStr.append(key, '');
    //                 }
    //                 setSelectedFilter({ ...selectedFilter, [key]: queryStr.get(key) })
    //                 break;
    //         }
    //     }
    //     console.log('______ After => ', queryStr.toString());
    // }

    //if (urlParams.length > 0) {
    queryStr = new URLSearchParams(urlParams.substring(1));
    initializeQueryStr("page", 1);
    initializeQueryStr("limit", 10);
    initializeQueryStr("username", selectedFilter.username);
    initializeQueryStr("category", selectedFilter.category);
    initializeQueryStr("event_type", selectedFilter.event_type);
    initializeQueryStr("search", selectedFilter.search);
    initializeQueryStr("end_date", selectedFilter.end_date);
    initializeQueryStr("start_date", selectedFilter.start_date);

    let val = queryStr.get("limit") * 1;
    if (val > 100) {
        val = 100;
    } else if (val > 10 && val <= 25) {
        val = 25;
    } else if (val > 25 && val < 100) {
        val = 50;
    }
    queryStr.set("limit", val);
    window.history.pushState({}, "", `?${queryStr.toString()}`);
    //}

    const columns = React.useMemo(
        () => [
            {
                Header: () => null,
                id: 'expander',
                canSort: false,
                Cell: ({ row }) => (
                    <span>
                        {row.isExpanded ? <DoubleArrowIcon className="expandCollapseRowIcon expand" /> : <DoubleArrowIcon className="expandCollapseRowIcon" />}
                    </span>
                ),
                width: 30
            },
            {
                Header: 'User Name',
                accessor: 'username',
            },
            {
                Header: 'Event Date',
                accessor: 'event_time',
                Cell: ({ row }) => {
                    let date = 'NA'
                    try {
                        date = moment.utc(row.original.event_time).format("YYYY-MM-DDTHH:mm:ssZ");
                    } catch (e) {
                        console.log('error ', e);
                    }
                    return (
                        <>
                            <span>
                                {date}
                            </span>
                        </>)
                },
            },
            {
                Header: 'Category',
                accessor: 'category',
                Cell: ({ row }) => {
                    return (
                        <span>
                            {categoryMap[row.original.category] ? categoryMap[row.original.category] : row.original.category}
                        </span>
                    );
                },
            },
            {
                Header: 'Event Type',
                accessor: 'event_type',
                Cell: ({ row }) => {
                    return (
                        <span>
                            {eventsMap[row.original.event_type]}
                        </span>
                    );
                },

            },
            {
                Header: 'Reason',
                accessor: 'reason',
            },
            {
                Header: 'Result',
                accessor: 'result',
            },
            {
                Header: 'Message',
                accessor: 'message',
                Cell: ({ row }) => {
                    try {
                        let message = parseMessage(row.original.message);
                        return (<> <ul className="messageList">
                            {message.map((v, i) => {
                                return <li key={`msg-${i}`}>{v}</li>
                            })}
                        </ul>
                        </>)
                    } catch (e) {
                        console.log('Error while parsing message ', e);
                        return ''
                    }
                },
            }
        ],
        []
    );

    // eslint-disable-next-line no-unused-vars
    const [rowsPerPage, setRowsPerPage] = React.useState(queryStr.get("limit") * 1);
    // eslint-disable-next-line no-unused-vars
    const [currentPage, setCurrentPage] = React.useState(queryStr.get("page") * 1);

    const applyFilter = () => {
        queryStr.set('username', selectedFilter.username);
        queryStr.set('event_type', selectedFilter.event_type);
        queryStr.set('category', selectedFilter.category);
        queryStr.set('search', selectedFilter.search);
        queryStr.set('end_date', selectedFilter.end_date);
        queryStr.set('start_date', selectedFilter.start_date);
    }
    const resetFilter = () => {
        setSelectedFilter({
            username: '',
            category: '',
            event_type: '',
            search: '',
            start_date: '',
            end_date: ''
        })
        //refresh page
        queryStr.set('username', '');
        queryStr.set('event_type', '');
        queryStr.set('category', '');
        queryStr.set('search', '');
        queryStr.set('end_date', '');
        queryStr.set('start_date', '');
        submitFilter();
    }
    const handleChangePage = (event, newPage) => {
        applyFilter();
        queryStr.set('page', newPage);
        setCurrentPage(newPage);
        fetchResultFor(queryStr)
    };
    const handleChangeRowsPerPage = (event) => {
        queryStr.set('limit', event.target.value);
        setRowsPerPage(event.target.value * 1);
        setCurrentPage(1); // rest on no. of rows per page change
        queryStr.set("page", 1);
        applyFilter();
        fetchResultFor(queryStr);
    };

    const submitFilter = () => {
        queryStr.set('limit', rowsPerPage);
        queryStr.set('page', 1);
        setCurrentPage(1);
        fetchResultFor(queryStr);
    }

    const fetchResultFor = (queryStr) => {
        reportAction.setCustomReportListLoader(true);
        window.history.pushState({}, "", `?${queryStr.toString()}`);
        reportAction.getEventLogs(queryStr.toString());
    }
    const fetchData = async (str) => {
        const queryStr = new URLSearchParams(str.substring(1));
        queryStr.set('limit', rowsPerPage);
        queryStr.set('page', 1);
        // initializeStateFromQueryStr(queryStr);
        // console.log('queryStr======> ', queryStr);
        await fetchResultFor(queryStr);
        // reportAction.getEventLogs();
    }

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'download-popper' : undefined;

    React.useEffect(() => {
        setLoadingState(true);
        userAction.getUserList();
        fetchData(props.location.search);
    }, []);


    let emailAddressList = userState.userList;

    React.useEffect(() => {
        prepareFilter(sortDataList(userState.userList, 'username', true));        
    }, [userState?.userList]);

    React.useEffect(() => {
        setLoadingState(false);

        if(reportState?.data?.data.length > 0) {
            setEventLogsList(sortDataList(reportState?.data?.data, 'username', true));
            setShowDownloadButton(true);
        } else {
            setShowDownloadButton(false);
            setEventLogsList([]);
        }

    }, [reportState?.data?.data])

    function getObjectDiff(obj1 = {}, obj2 = {}) {
        const diff = Object.keys(obj1).reduce((result, key) => {
            if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
                result.push(key);
            } else if (_.isEqual(obj1[key], obj2[key])) {
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(obj2));

        return diff;
    }

    // const filterProps = (obj)=> {
    //     return {}
    // }
    function parseMessage(data) {
        let ret = [];
        if (!data)
            return ret;
        if (data && data.trim().length === 0)
            return ret;
        try {
            ret = JSON.parse('[' + data + ']');
            let values = [];
            for (let i = 0; i < ret.length; i++) {
                values = values.concat(Object.values(ret[i]).toString());
            }
            return values;
        } catch (e) {
            ret[0] = data;
        }
        return ret;
    }
    const renderRowSubComponent = React.useCallback(
        ({ row }) => {
            if (row.original.event_type === 'IMPORT_RUN' && row.original.category === 'import_job') {
                try {
                    let currentData = row.original.current_version;
                    return (<>
                        <fieldset style={{ width: '70%', marginLeft: '10px' }}>
                            <legend>Import Job Details :</legend>
                            <Grid container className="import_job_details">
                                <Grid className="label_info" item md={2}>
                                    User Name
                                </Grid>
                                <Grid item md={10}>
                                    {currentData.user_name}
                                </Grid>
                            </Grid>
                            <Grid container className="import_job_details">
                                <Grid className="label_info" item md={2}>
                                    Import Type
                                </Grid>
                                <Grid item md={10}>
                                    {currentData.import_type_title}
                                </Grid>
                            </Grid>
                            <Grid container className="import_job_details">
                                <Grid className="label_info" item md={2}>
                                    Import Job Name
                                </Grid>
                                <Grid item md={10}>
                                    {currentData.title}
                                </Grid>
                            </Grid>
                            <Grid container className="import_job_details">
                                <Grid className="label_info" item md={2}>
                                    Status
                                </Grid>
                                <Grid item md={10}>
                                    {currentData.current_status}
                                </Grid>
                            </Grid>
                            <Grid container className="import_job_details">
                                <Grid className="label_info" item md={2}>
                                    Timestamp
                                </Grid>
                                <Grid item md={10}>
                                    {currentData.create_date}
                                </Grid>
                            </Grid>
                        </fieldset>
                    </>
                    )
                } catch (e) {
                    console.log('Error ', e);
                    return (<><p style={{ marginLeft: '10px' }}>No information available</p></>)
                }
            }
            let obj1 = {};
            let obj2 = {};
            let message = parseMessage(row.original.message);
            if (row.original.previous_version && row.original.previous_version != null) {
                obj1 = row.original.previous_version;
            }

            if (row.original.current_version && row.original.current_version != null) {
                obj2 = row.original.current_version;
            }
            let d1 = getObjectDiff(
                obj1,
                obj2)
            let d2 = getObjectDiff(
                obj2,
                obj1);

            let resultObj1 = {};
            let resultObj2 = {};

            for (let i = 0; i < d1.length; i++) {
                let propName = d1[i];
                if (row.original.category === 'config') {
                    resultObj1[propName] = obj1[propName];
                } else {
                    if (!filterProps[propName]) {
                        resultObj1[UI_LABELS[propName]] = obj1[propName];
                    }
                }
            }
            for (let i = 0; i < d2.length; i++) {
                let propName = d2[i];
                if (row.original.category === 'config') {
                    resultObj2[propName] = obj2[propName];
                } else {
                    if (!filterProps[propName]) {
                        resultObj2[UI_LABELS[propName]] = obj2[propName];
                    }
                }
            }

            return (
                <Grid container style={{ paddingTop: '8px', paddingLeft: '9px' }}>
                    {/* <Grid item md={5} className="details">
                        <Typography style={{ textDecoration: 'underline' }}>
                            Previous Version
                        </Typography>
                        <pre className="details_text"><code>{JSON.stringify(row.original.previous_version, null, '\t')}</code></pre>
                    </Grid>
                    <Grid item md={5} className="details">
                        <Typography style={{ textDecoration: 'underline' }}>
                            Current Version
                        </Typography>
                        <pre className="details_text"><code>{JSON.stringify(row.original.current_version, null, '\t')}</code></pre>
                    </Grid> */}
                    <Typography style={{ fontSize: 'small' }}>
                        {row.original.result}: Operation {row.original.event_type} by {row.original.username} on {row.original.event_time} {message.length > 0 ? `with message - ${message.join()}` : ''}
                    </Typography>
                    {(d1.length != 0 || d2.length != 0) && <ReactDiffViewer
                        disableWordDiff={true}
                        oldValue={JSON.stringify(resultObj1, null, '\t')}
                        newValue={JSON.stringify(resultObj2, null, '\t')}
                        splitView={true}
                        compareMethod={DiffMethod.WORDS}
                        styles={newStyles}
                        leftTitle="Previous Version"
                        rightTitle="Current Version"
                        showDiffOnly
                    >
                    </ReactDiffViewer>}
                </Grid>
            )
        },
        []
    )
    const [expanded, setExpanded] = React.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const prepareFilter = (userListData) => {
        const userNameSet = new Set();
        if (userListData) {
            for (let i = 0; i < userListData.length; i++) {
                userNameSet.add(userListData[i].username);
            }
        }

        setFilterData({
            ...filterData,
            username: [...userNameSet.values()],
        })
    }
    const userEmail = JSON.parse(LocalStorageService.getUserInfo());

    const getInitialValues = () => {
        return {
          emailAddressField: [userEmail.email],
        }
      }


      const onFormSubmit = async (values) => {
        applyFilter();
        const emails = [];
            values.emailAddressField.map((user) => {
            emails.push(user.email);
        })
        const dataModel = {
            recipients: emails,
            filters: {
                start_date: selectedFilter.start_date !== '' ? selectedFilter.start_date : null,
                end_date: selectedFilter.end_date !== '' ? selectedFilter.end_date : null,
                search: selectedFilter.search !== '' ? selectedFilter.search : null,
                category: selectedFilter.category !== '' ? selectedFilter.category : null,
                event_type: selectedFilter.event_type !== '' ? selectedFilter.event_type : null,
                username: selectedFilter.username !== '' ? selectedFilter.username : null
            }
        }

        try {
            reportAction.downloadUserLogs(dataModel);
            setEmailAddressFieldKey(new Date().getTime());
        } catch (err) {
          console.log(err);
        }
      };

      React.useEffect(() => {
        if(reportStateDownload?.data.message !== undefined) {
            setResponseReceived(true);
        } else {
            setResponseReceived(false);
        }
        if(reportStateDownload?.data.success === true) {
            setTimeout(() => {
                setAnchorEl(null);
                setResponseReceived(false);
            }, 3000);
        }
      }, [reportStateDownload?.data])


    return (
        <>
            <DisplayBreadcrumbs items={[{ title: 'Event Logs', link: '' } ]} />
            {showDownloadButton && (
                <Grid container>
                    <Grid item md={12} style={{display: 'flex', paddingTop: '10px', paddingBottom: '10px', paddingRight: '4%', justifyContent: 'right'}}>
                        <Tooltip title="Download">
                            <GetAppIcon fontSize="large" style={{cursor: 'pointer'}} aria-describedby={id} type="button" onClick={handleClick}></GetAppIcon>
                        </Tooltip>
                        <Popper id={id} open={open} anchorEl={anchorEl}>
                            <div className="download-pane-wrapper">
                                <Grid container>
                                    <Grid item md={12}>
                                        <Formik
                                        initialValues={getInitialValues()}
                                        onSubmit={onFormSubmit}
                                        >
                                            {(propsFormik) => {
                                                const {
                                                    values,
                                                    setFieldValue,
                                                    handleSubmit,
                                                } = propsFormik;
                                                return (
                                                    <>
                                            <form onSubmit={handleSubmit}>

                                            <EnhancedAutoComplete
                                            id="emailAddressField"
                                            values={values}
                                            key={emailAddressFieldKey}
                                            multiple
                                            optionsStyle={{
                                                'paddingBottom': '8px',
                                                'paddingTop': '8px'
                                            }}
                                            emailAddressList={emailAddressList}
                                            options={emailAddressList}
                                            //defaultValue={[userEmail.email]}
                                            getOptionLabel={(option) => {
                                                return option.email;
                                            }}
                                            renderOptionFunction={(option) => {
                                            let dataItem = `${option.email} (${option.username})`;
                                            return (
                                                <>
                                                <Tooltip title={dataItem} style={{ width: '100%' }}>
                                                    <Typography variant="body2" noWrap={true}>
                                                    {dataItem}
                                                    </Typography>
                                                </Tooltip>
                                                </>
                                            )
                                            }}
                                            label="Add email address"
                                            handleOnChange={
                                                (e, value) => {
                                                    setFieldValue('emailAddressField', value);
                                                }
                                            }
                                            ></EnhancedAutoComplete>

                                            <Grid container>
                                                <Grid item md={12} style={{display: 'flex', justifyContent: 'center', paddingTop: '20px'}}>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={()=> setAnchorEl(null)}
                                                    >
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type='submit'
                                                        style={{marginLeft: '25px'}}
                                                    >
                                                        OK
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                            </>
                                        )

                                        }}

                                        </Formik>

                                            {
                                                responseReceived && (

                                                    <Alert severity="info" style={{marginTop: '20px'}}>
                                                        {
                                                            reportStateDownload?.data.success === true &&
                                                            (
                                                                <Typography style={{color: 'green'}}>
                                                                    Emailed successfully!
                                                                </Typography>
                                                            )
                                                        }

                                                        {
                                                            reportStateDownload?.data.success !== true &&
                                                            (
                                                                <Typography style={{color: 'red'}}>
                                                                    {reportStateDownload?.data.message}
                                                                </Typography>
                                                            )
                                                        }
                                                    </Alert>
                                                )
                                            }

                                    </Grid>
                                </Grid>
                            </div>
                        </Popper>
                    </Grid>
                </Grid>
            )}

            <Grid container className="advFilter" onClick={handleExpandClick}>
                <Grid item md={6} className="filterTitleSection">
                    <Typography style={{ fontSize: '17px', alignSelf: 'center' }}>
                        Advanced Filter
                    </Typography>
                </Grid>
                <Grid item md={6} className="filterTitleSection">
                    <DoubleArrowIcon className={expanded ? 'expand' : 'collapse'} ></DoubleArrowIcon>
                </Grid>
            </Grid>
            <Collapse in={expanded} timeout="auto" unmountOnExit className="collapse_panel">
                <Grid container style={{ marginTop: '16px' }}>
                    <Grid item md={4}>
                        <FormControl variant="outlined" className="formField">
                            <InputLabel id="usernameSelect">User Name</InputLabel>
                            <Select
                                label="User Name"
                                id="usernameSelect"
                                labelId="usernameSelect"
                                value={selectedFilter.username}
                                onChange={e => {
                                    setSelectedFilter({ ...selectedFilter, username: e.target.value })
                                }}
                            >
                                <MenuItem value="" style={{ textTransform: 'capitalize', fontSize: 'small' }}>None</MenuItem>
                                {filterData.username.map((option, i) => (
                                    <MenuItem key={i} value={option} style={{ fontSize: 'small' }}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={4}>
                        <FormControl variant="outlined" className="formField">
                            <InputLabel id="categorySelect">Category</InputLabel>
                            <Select
                                label="Category"
                                variant="outlined"
                                fullWidth
                                labelId="categorySelect"
                                id="categorySelect"
                                value={selectedFilter.category}
                                onChange={e => {
                                    setSelectedFilter({ ...selectedFilter, category: e.target.value })
                                }}
                            >
                                <MenuItem value="" style={{ textTransform: 'capitalize', fontSize: 'small' }}>None</MenuItem>
                                {filterData.category.map((option, i) => (
                                    <MenuItem key={i} value={option} style={{ fontSize: 'small' }}>
                                        {categoryMap[option] ? categoryMap[option] : option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={4}>
                        <KeyboardDatePicker
                            className="formField"
                            variant="inline"
                            inputVariant="outlined"
                            label="From Date"
                            placeholder={globalDateEntity.datePickerFormat}
                            format={globalDateEntity.datePickerFormat}
                            autoOk
                            id="start_date"
                            name="start_date"
                            value={selectedFilter.start_date ? selectedFilter.start_date : null}
                            onChange={(v) => {
                                if (v === null || v === undefined) {
                                    setSelectedFilter({
                                        ...selectedFilter, start_date: ''
                                    });

                                } else {
                                    let date = moment(v)
                                    setSelectedFilter({
                                        ...selectedFilter, start_date: date.format('YYYY-MM-DD')
                                    });
                                }
                            }}
                            minDate={new Date(DatepickerStartDate)}
                            minDateMessage={stringConstants.minDate}
                        />
                    </Grid>
                </Grid>
                <Grid container style={{ marginTop: '16px' }}>
                    <Grid item md={4}>
                        <FormControl variant="outlined" className="formField">
                            <InputLabel id="event_type">Event Type</InputLabel>
                            <Select
                                label="Event Type"
                                variant="outlined"
                                id="event_type"
                                labelId="event_type"
                                value={selectedFilter.event_type}
                                onChange={e => {
                                    setSelectedFilter({ ...selectedFilter, event_type: e.target.value })
                                }}
                            >
                                <MenuItem value="" style={{ textTransform: 'capitalize', fontSize: 'small' }}>None</MenuItem>
                                {filterData.event_type.map((option, i) => (
                                    <MenuItem key={i} value={option} style={{ fontSize: 'small' }}>
                                        {eventsMap[option] ? eventsMap[option] : option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            id="search"
                            label="Entity Name"
                            placeholder="Entity Name"
                            className="formField"
                            variant="outlined"
                            value={selectedFilter.search}
                            onChange={(e) => setSelectedFilter({
                                ...selectedFilter, search: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item md={4}>
                        <KeyboardDatePicker
                            className="formField"
                            variant="inline"
                            inputVariant="outlined"
                            label="To Date"
                            placeholder={globalDateEntity.datePickerFormat}
                            format={globalDateEntity.datePickerFormat}
                            autoOk
                            id="end_date"
                            name="end_date"
                            value={selectedFilter.end_date ? selectedFilter.end_date : null}
                            onChange={(v) => {
                                if (v === null || v === undefined) {
                                    setSelectedFilter({
                                        ...selectedFilter, end_date: ''
                                    });
                                } else {
                                    let date = moment(v)
                                    setSelectedFilter({
                                        ...selectedFilter, end_date: date.format('YYYY-MM-DD')
                                    });
                                }
                            }}
                            minDate={new Date(DatepickerStartDate)}
                            minDateMessage={stringConstants.minDate}
                        />
                    </Grid>
                </Grid>
                <Grid container style={{ paddingTop: '24px' }} className="filterTitleSection">
                    <Button style={{ marginRight: '24px', paddingLeft: '24px' }} variant="contained" color="primary" onClick={() => {
                        resetFilter();
                        //submitFilter();
                        setShowDownloadButton(false);
                    }}>
                        Reset Filter
                    </Button>

                    <Button variant="contained" style={{ marginRight: '24px' }} color="secondary" onClick={() => {
                        applyFilter();
                        submitFilter();

                    }}>
                        Apply Filter
                    </Button>
                </Grid>


            </Collapse>
            {loadingState === true && (
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <p style={{ fontWeight: 'bold' }}>{stringConstants.LoadingText}</p>
                    <CircularProgress />
                </div>
            )
            }
            {!loadingState && reportState &&
                reportState.data &&
                reportState.data.data.length === 0 && (
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        {stringConstants.noRecordFound}
                    </div>
                )
            }

            {!loadingState && reportState &&
                reportState.data &&
                reportState.data.data.length > 0 && (
                    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
                        <SubmitSnackbar />
                        <Grid container direction="row">
                            <Grid item md={12} style={{ padding: '20px 0 0' }}>
                                <EnhancedParentChildTable
                                    columns={columns}
                                    data={eventLogsList}
                                    skipPageReset={false}
                                    paginationMode="server"
                                    handleChangePage={handleChangePage}
                                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    pages={reportState.data.pages}
                                    limit={rowsPerPage}
                                    currentPage={currentPage}
                                    renderRowSubComponent={renderRowSubComponent}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
        </>
    )
};
export default EventLogs;
